import React, { useState } from "react";
import "./ForgotPassword.css";
const EyeIcon = () => (
  <svg width="22" height="15" viewBox="0 0 22 15" fill="none">
    <path
      d="M1 7.5C1 7.5 4.5 1.5 11 1.5C17.5 1.5 21 7.5 21 7.5C21 7.5 17.5 13.5 11 13.5C4.5 13.5 1 7.5 1 7.5Z"
      stroke="#7C709C"
      strokeWidth="2"
    />
    <circle cx="11" cy="7.5" r="3.5" stroke="#7C709C" strokeWidth="2" />
  </svg>
);

const EyeOffIcon = () => (
  <svg width="22" height="18" viewBox="0 0 24 24" fill="none">
    <path
      d="M17.94 17.94A10.94 10.94 0 0 1 12 19c-7 0-10-7-10-7a21.8 21.8 0 0 1 5.06-5.94"
      stroke="#7C709C"
      strokeWidth="2"
    />
    <path
      d="M9.9 4.24A10.94 10.94 0 0 1 12 5c7 0 10 7 10 7a21.8 21.8 0 0 1-4.06 5.06"
      stroke="#7C709C"
      strokeWidth="2"
    />
    <path
      d="M14.12 14.12A3 3 0 1 1 9.88 9.88"
      stroke="#7C709C"
      strokeWidth="2"
    />
    <line x1="1" y1="1" x2="23" y2="23" stroke="#7C709C" strokeWidth="2" />
  </svg>
);


function ForgotPassword({ setPage }) {
  const [step, setStep] = useState("email");
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [newPassword, setNewPassword] = useState("");
const [confirmPassword, setConfirmPassword] = useState("");
const [showPassword, setShowPassword] = useState(false);

  const handleOtpChange = (value, index) => {
    if (!/^[0-9]?$/.test(value)) return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (value && index < 5) {
      document.getElementById(`otp-${index + 1}`).focus();
    }
  };

  return (
    <div className="forgot-page">
      <div className="forgot-card">
        <div className="brand">
          <div className="logo">P</div>
          <h1>Parking MS</h1>
        </div>

        {step === "email" && (
          <>
            <h2>Forgot Password</h2>
            <p className="subtitle">Enter the mail id to reset password</p>

            <label>Email Address</label>
            <div className="input-box">
              <span>✉</span>
              <input
                type="email"
                placeholder="Enter Your Email ID"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>

            <button className="main-btn" onClick={() => setStep("otp")}>
             <p className="reset-text">Reset Password</p> 
            </button>

            <p className="bottom-text">
  Remember Password{" "}
  <span onClick={() => setPage("login")}>Sign In</span>
</p>
          </>
        )}

{step === "otp" && (
          <>
            <h2>Enter the six-digit code.</h2>
            <p className="subtitle">
              Please enter the six-digit code sent to <br /> your email ID.
            </p>

            <div className="otp-row">
              {otp.map((num, index) => (
                <input
                  key={index}
                  id={`otp-${index}`}
                  maxLength="1"
                  value={num}
                  onChange={(e) => handleOtpChange(e.target.value, index)}
                />
              ))}
            </div>

            <p className="resend">
              Haven’t received the OTP? <span>Resend OTP</span>
            </p>

            <button
              className={otp.every((n) => n !== "") ? "main-btn" : "disabled-btn"}
              onClick={() => {
    if (otp.every((n) => n !== "")) {
      setStep("reset");
    }
  }}
            >
              <h3 className="reset-text">Reset Password</h3>
            </button>

            <p className="bottom-text">
              Remember Password <span>Sign In</span>
            </p>
          </>
        )}
        {step === "reset" && (
  <>
    <h2>Sign In to Parking MS</h2>

    <p className="subtitle">
      Access your parking terminal controller
    </p>

    <label>Enter Password</label>
    <div className="input-box">
      <span className="lock-icon">
  <svg
    width="70"
    height="140"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7 10V7C7 4.24 9.24 2 12 2C14.76 2 17 4.24 17 7V10"
      stroke="#7C709C"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />

    <rect
      x="5"
      y="10"
      width="14"
      height="11"
      rx="2"
      stroke="#7C709C"
      strokeWidth="2"
    />

    {/* Center Dot */}
    <circle
      cx="12"
      cy="15.5"
      r="1.5"
      fill="#7C709C"
    />
  </svg>
</span>
      <input
        type={showPassword ? "text" : "password"}
        placeholder="Enter New Password"
        value={newPassword}
        onChange={(e) => setNewPassword(e.target.value)}
      />
      <button
  type="button"
  className="eye-icon"
  onClick={() => setShowPassword(!showPassword)}
>
  {showPassword ? <EyeOffIcon /> : <EyeIcon />}
</button>
    </div>

    <div className="label-row">
  <label>Re-Enter Password</label>
  <span className="forgot-link">Forgot Password?</span>
</div>

<div className="input-box">
      <span className="lock-icon">
  <svg
    width="70"
    height="140"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7 10V7C7 4.24 9.24 2 12 2C14.76 2 17 4.24 17 7V10"
      stroke="#7C709C"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />

    <rect
      x="5"
      y="10"
      width="14"
      height="11"
      rx="2"
      stroke="#7C709C"
      strokeWidth="2"
    />

    {/* Center Dot */}
    <circle
      cx="12"
      cy="15.5"
      r="1.5"
      fill="#7C709C"
    />
  </svg>
</span>
      <input
        type={showPassword ? "text" : "password"}
        placeholder="Re-Enter Your Password"
        value={confirmPassword}
        onChange={(e) => setConfirmPassword(e.target.value)}
      />
      <button
  type="button"
  className="eye-icon"
  onClick={() => setShowPassword(!showPassword)}
>
  {showPassword ? <EyeOffIcon /> : <EyeIcon />}
</button>
    </div>

    <button className="main-btn" onClick={() => setStep("success")}>
  <p className="reset-text">Reset Password</p>
</button>
    <p className="signup-text">
  Don't have an account?
  <span className="signup-link"> Sign up for a new account</span>
</p>
  </>
)}
{step === "success" && (
  <>
    <h2 className="success-title">Password Resetted</h2>

    <p className="success-subtitle">
      Now You can use your new password <br />
      to log in.
    </p>

    <div className="success-icon">
  <svg width="157" height="157" viewBox="0 0 157 157" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M22.9919 134.007C30.1998 141.215 38.5943 146.874 47.9425 150.828C57.6235 154.923 67.9043 157 78.4996 157C89.0949 157 99.3758 154.923 109.057 150.828C118.405 146.874 126.799 141.215 134.007 134.007C141.215 126.799 146.874 118.405 150.828 109.057C154.924 99.3758 156.999 89.0949 156.999 78.4996C156.999 70.0314 155.658 61.699 153.011 53.7339C152.158 51.1658 149.384 49.7756 146.816 50.6288C144.248 51.482 142.858 54.2557 143.711 56.824C146.025 63.7906 147.199 71.0833 147.199 78.4996C147.199 96.8498 140.053 114.102 127.077 127.077C114.102 140.053 96.8498 147.199 78.4996 147.199C60.1493 147.199 42.8973 140.053 29.9218 127.077C16.9463 114.102 9.80023 96.8498 9.80023 78.4996C9.80023 60.1493 16.9463 42.8975 29.9218 29.9218C42.8973 16.9463 60.1493 9.80023 78.4996 9.80023C90.5058 9.80023 102.32 12.9413 112.666 18.8839C115.012 20.2323 118.007 19.4223 119.355 17.0759C120.703 14.7291 119.894 11.734 117.547 10.386C105.719 3.59152 92.2161 0 78.4996 0C67.9043 0 57.6235 2.07619 47.9425 6.17087C38.5943 10.1249 30.1998 15.7843 22.9919 22.9921C15.7843 30.1998 10.1249 38.5943 6.17087 47.9425C2.07619 57.6235 0 67.9044 0 78.4996C0 89.0949 2.07619 99.3758 6.17087 109.057C10.1249 118.405 15.7843 126.799 22.9919 134.007Z" fill="#41B263"/>
<path d="M65.7058 89.2991C65.7058 89.2991 56.3839 83.3772 45.1252 74.2878C42.7098 72.3379 39.158 72.7771 37.2938 75.2594C35.9395 77.0626 35.8286 79.509 37.0103 81.4297C42.7067 90.6884 52.5486 105.288 60.1596 114.88C63.7511 119.406 70.1269 119.825 74.3178 115.847C98.4209 92.9703 120.793 64.1093 147.581 24.1473C149.134 21.8299 148.353 18.6783 145.895 17.3591C144.017 16.3515 141.696 16.728 140.233 18.2772C110.516 49.7427 95.2753 64.698 65.7058 89.2991Z" fill="#41B263"/>
</svg>

</div>

    <button
  className="main-btn return-btn"
  onClick={() => setPage("login")}
>
  <p className="reset-text">Return to Log In</p>
</button>
  </>
)}
        
      </div>

      <div className="footer-links">
        <span>Privacy Policy</span>
        <span>Terms of Service</span>
        <span>Help Center</span>
      </div>
    </div>
  );
}

export default ForgotPassword;